<template lang="pug">
    
footer( :class="styles.root" )
    div(
        :class="styles.description"
    ) 
        TheText(
            :class="styles.text"
            name="caption"
            color="foreground400"
        ) Удобные платежи для бизнеса вместе с
        Logo(
            :class="styles.logo"
        )
    div(
        :class="styles.links"
    )
        a(
            target="_blank"
            rel="noopener noreferrer"
            href="docs/offer.pdf"
        ) Публичная оферта
        a(
            target="_blank"
            rel="noopener noreferrer"
            href="docs/policy.pdf"
        ) Политика конфиденциальности
    ImageSvg(
        :class="styles.pci"
        src="images/common/pci-logo.svg"
        height="16"
        width="auto"
        @click="isShow = !isShow"
    )
    p(
        v-if="state.serverTime && isShow"
        :class="styles.debug"
    ) Server time: {{new Date(state.serverTime)}}
    p(
        v-if="env.BUILD_VERSION && isShow"
        :class="styles.debug"
    ) Build: {{env.BUILD_VERSION}}
</template>

<script lang="ts">
import Vue, { ref, useCssModule } from 'vue'

import { ImageSvg } from '@/shared/ui/ImageSvg'
import { TheText } from '@/shared/ui/TheText'
import { Logo } from '@/shared/ui/Logo'
import { useAppStore } from '@/shared/model'
import { env } from '@/shared/config'

export default Vue.extend({
    name: 'Footer',
    computed: {
        env() {
            return env
        },
    },
    setup() {
        const styles = useCssModule()
        const { state } = useAppStore()

        const isShow = ref(false)

        return {
            styles,
            state,
            isShow,
        }
    },
    components: { Logo, TheText, ImageSvg },
})
</script>

<style module lang="scss" src="./Footer.module.scss" />
